import { render } from "./YearShowList.vue?vue&type=template&id=5a084572"
import script from "./YearShowList.vue?vue&type=script&lang=ts"
export * from "./YearShowList.vue?vue&type=script&lang=ts"
script.render = render

export default script